import { EventDetails } from 'types/Event'
import { SellingTypeMap, SoldTicketInfo } from 'types/Ticket'

import { httpClient } from './clients/httpClient'

export interface TicketDetailsDTO {
    eventDetails: EventDetails
    ticketId: string
}

export const generateTicket = async (ticketDetails: TicketDetailsDTO): Promise<Blob> => {
    try {
        const { data } = await httpClient.post<Blob>('/generate-ticket', ticketDetails, {
            responseType: 'blob',
        })

        return data
    } catch (error: any) {
        console.error('Error generating ticket:', error.response?.data || error.message)
        throw new Error('Failed to generate ticket')
    }
}

export const generateMergedTickets = async (ticketDetailsList: TicketDetailsDTO[]): Promise<Blob> => {
    try {
        const { data } = await httpClient.post<Blob>(
            '/generate-ticket/merged',
            { tickets: ticketDetailsList },
            {
                responseType: 'blob',
            },
        )

        return data
    } catch (error: any) {
        console.error('Error generating merged tickets:', error.response?.data || error.message)
        throw new Error('Failed to generate merged tickets')
    }
}

export const scanTicket = async (ticketId: string, eventId: string): Promise<any> => {
    try {
        const { data } = await httpClient.post(`/tickets/event/${eventId}/scan/${ticketId}`)
        return data
    } catch (error: any) {
        const message = error.response?.data?.message || 'Érvénytelen jegy'
        throw new Error(message)
    }
}

export const getTicketStatuses = async (seatIds: string[], eventId: string): Promise<any> => {
    try {
        const { data } = await httpClient.post('/tickets/status', { seatIds, eventId })
        return data
    } catch (error: any) {
        console.error('Error fetching ticket statuses:', error.response?.data || error.message)
        throw new Error('Failed to fetch ticket statuses')
    }
}

export const getSellingTypeForSeats = async (eventId: string): Promise<SellingTypeMap[]> => {
    try {
        const { data } = await httpClient.get<SellingTypeMap[]>(`/tickets/${eventId}/sellingtypemap`)
        return data
    } catch (error: any) {
        console.error('Error fetching selling types for seats:', error.response?.data || error.message)
        throw new Error('Failed to fetch selling types for seats')
    }
}

export const releaseTickets = async (eventId: string, seatIds: string[]): Promise<any> => {
    try {
        const { data } = await httpClient.post(`/tickets/${eventId}/release`, { seatIds })
        return data
    } catch (error: any) {
        console.error('Error releasing tickets:', error.response?.data || error.message)
        throw new Error('Failed to release tickets')
    }
}

export const getSoldTicketsInfo = async (eventId: string): Promise<Record<string, SoldTicketInfo>> => {
    try {
        const { data } = await httpClient.get<Record<string, SoldTicketInfo>>(`/tickets/${eventId}/sold-info`)
        return data
    } catch (error: any) {
        console.error('Error fetching sold tickets info:', error.response?.data || error.message)
        throw new Error('Failed to fetch sold tickets info')
    }
}
